import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';
import Const from 'constants';

const defaultAcceptTypes = {
    'text/csv': ['.csv'],
};

function FileUploader(props) {
    const {accept = defaultAcceptTypes, handleUploadedFiles, dispatch, isLoading} = props;

    const onDropAccepted = useCallback((acceptedFiles) => {
        handleUploadedFiles(acceptedFiles);
    }, []);

    const {getRootProps, getInputProps, fileRejections, isDragReject, isDragAccept} = useDropzone({
        onDropAccepted,
        accept: {...accept},
    });

    let message;
    if (!isEmpty(fileRejections)) {
        message = <p>Only CSV extension is allowed.</p>;
    }

    const getClassName = () => {
        let className = '';

        className += isDragAccept ? ' drag-accept' : '';
        className += isDragReject || fileRejections.length ? ' drag-reject' : '';

        return className;
    };

    return (
        <section className={`dropzone-container ${getClassName()} ${isLoading ? 'loading' : ''}`}>
            <button
                type="button"
                className="btn-dropzone-close"
                onClick={() => dispatch({type: Const.HIDE_DROPZONE})}
            ></button>
            <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />

                <p>Drag 'n' drop some files here, or click to select files</p>

                {message && <div className="drop-error">{message}</div>}
            </div>
        </section>
    );
}
export {FileUploader};
